import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "./../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import FooterOne from "../../components/Footer/FooterOne";
import HeadingSection from "../../components/HeadingSection/HeadingSection";
import Gallery from "../../components/Gallery/Gallery";
import CTAOne from "../../components/CTA/CTAOne";
import { IoSearch } from "react-icons/io5";
import { Link } from "react-router-dom"; // Import Link

const Search = () => {
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=properties`;
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const jwt = localStorage.getItem("jwtToken");
        const response = await fetch(API_URL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
        });
        const result = await response.json();
        setData(result);
        setFilteredData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [API_URL]);

  const handleSearch = () => {
    const filtered = data.filter((property) =>
      property.Address1.toLowerCase().includes(searchTerm.toLowerCase()) ||
      property.Neighborhood.toLowerCase().includes(searchTerm.toLowerCase()) ||
      property.Notes.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
  };

  return (
    <Loader>
      <HeaderOne />
      <section className="mt-minus-50">
        <div className="container mt-minus-50">
          <div className="row ">
            <div className="dark-color mt-250 h2 center">
             SEARCH ALL PROPERTIES
            </div>
          </div>

          <div className="row mt-50 pb-50">
            <div className="col-md-6 mb-0 col-sm-6 border1red">
              <a href="https://olshangroup.olshan.com/idx/search/advanced" target="_blank" rel="noopener noreferrer">
                <h1 className="alllistings">EVERY LISTING IN NYC</h1>
                <h3>ALL IN ONE PLACE</h3>
                <button
                  type="submit"
                  className="btn btn-red btn-square"
                  data-aos="fade-up"
                  data-aos-delay={100}
                  data-aos-duration={700}
                >
                  SEARCH NOW
                </button>
              </a>
            </div>

            <div className="col-md-6 mb-0 col-sm-6 border1red">
              <a href="https://olshangroup.olshan.com/idx/search/hud" target="_blank" rel="noopener noreferrer">
                <h4>EVERY LISTING IN ROCKLAND, WESTCHESTER, DUCHESS, PUTNAM, ORANGE, BRONX, ALBANY, RENSSELAER & COLUMBIA COUNTIES</h4>
                <h3>ALL IN ONE PLACE</h3>
                <button
                  type="submit"
                  className="btn btn-red btn-square"
                  data-aos="fade-up"
                  data-aos-delay={100}
                  data-aos-duration={700}
                >
                  SEARCH NOW
                </button>
              </a>
            </div>
          </div>

          <div className="row mt-minus-50">
          <div className="dark-color mt-250 h2 center">
             SEARCH PROPERTIES ON OLSHAN.COM
            </div>
          </div>

          {/* Search Bar */}
          <div className="widget sidebar_widget">
            <div className="search-bar" style={{ display: "flex", alignItems: "center", position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search by address, neighborhood, or notes..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  handleSearch();
                }}
                style={{ flex: 1, paddingRight: "50px" }}
              />
              <IoSearch
                className="search-icon"
                style={{
                  position: "absolute",
                  right: "15px",
                  color: "red",
                  fontSize: "28px",
                  cursor: "pointer",
                }}
              />
            </div>

            {/* Display Filtered Results */}
            <div className="row mt-50">
              {filteredData.length > 0 ? (
                filteredData.slice(0, 20).map((property) => (
                  <div
                    className="col-md-4 mb-4"
                    key={property.WebId}
                    data-aos="fade-up"
                  >
                    <div className="property-card">
                      <Link to={`/property/${property.WebId}`}>
                        <img
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${property.WebId}/large1.jpg`}
                          alt={property.Address1}
                          className="img-fluid"
                        />
                      </Link>
                      <div className="property-info">
                        <h4>{property.Address1}</h4>
                        <p></p>
                        <h5>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }).format(property.Price)} in {property.Neighborhood}
                        </h5>
                        <p>{property.Notes}</p>
                        
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No results found.</p>
              )}
            </div>
          </div>
        </div>

        <div
          id="script"
          dangerouslySetInnerHTML={{
            __html: `<script charset="UTF-8" type="text/javascript" id="idxwidgetsrc-80326" src="//olshangroup.olshan.com/idx/widgets/80326"></script>`,
          }}
        />
      </section>

      <Gallery
        title="FEATURED OLSHAN PROPERTIES"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
      />

      <CTAOne
        tagline="Olshan Luxury Report"
        title="Highly focused. Data Driven."
        textButton="GET THE LATEST LUXURY REPORT"
        linkButton="/market-report"
        bg="color"
      >
        This report is the only one of its kind. On a weekly basis, Olshan
        publishes a report covering all the contract activity in the luxury
        market on properties at $4 million and above. The free report draws
        subscribers from all over the world, and is frequently quoted in the New
        York Times, Wall Street Journal, Crain's, Observer, The Real Deal and
        various media outlets.
      </CTAOne>

      <FooterOne />
    </Loader>
  );
};

export default Search;
